
import React, { Component } from 'react'
import axios from 'axios'
import { NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css';


const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
const token = localStorage.getItem("token");
class Addcart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productid: id,
      userid: loggedInUserID,
      qty: ''

    }
    this.createNotification = this.createNotification.bind(this);

  }
   backtologin(event) {
    event.preventDefault();
    window.location.replace("/Login");
  }

  createNotification = (type) => {
    return () => {
      switch (type) {
        case 'info':
          NotificationManager.info('Info message');
          break;
        case 'success':
          NotificationManager.success('Success message', 'Title here');
          break;
        case 'warning':
          NotificationManager.warning('Warning message', 'Close after 3000ms', 3000);
          break;
        case 'error':
          NotificationManager.error('Error message', 'Click me!', 5000, () => {
            alert('callback');
          });
          break;
      }
    };
  };


  changeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
  }



  submitHandler = e => {
    e.preventDefault()
    console.log(this.state)
    axios
      .post('https://shoppee-clone.herokuapp.com/cartitem', this.state, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        NotificationManager.success('Added to cart');
        console.log(response)

      })
      .catch(error => {
        NotificationManager.error('Error ');
        console.log(error)
      })
  }

  render() {
    const { qty } = this.state
    if (token != null ) {
      return (
        <div>
  
              <div className="d-flex flex-column ">
                <form onSubmit={this.submitHandler}>
                  <div className="d-flex justify-content-center">
                    <input type="number" name="qty" value={qty} onChange={this.changeHandler} id="qty" placeholder="Item Qty" className="form-control-sm " required />
                  </div>
                  <div className="d-flex mt-3 justify-content-center">
                    <button type="submit" className="px-sm-5 px-3 py-2 btn btn-dark" value="post"><i class="bi bi-cart-plus"></i>&nbsp;Add to cart </button>
                  </div>
                </form>
              </div>
        </div>
      )
    } else {
      return (
        <div>
  
              <div className="d-flex flex-column ">
                <form onSubmit={this.backtologin}>
                  <div className="d-flex justify-content-center">
                    <input type="number" name="qty" value={qty} onChange={this.changeHandler} id="qty" placeholder="Item Qty" className="form-control-sm " required />
                  </div>
                  <div className="d-flex mt-3 justify-content-center">
                    <button type="submit" className="px-sm-5 px-3 py-2 btn btn-dark" value="post"><i class="bi bi-cart-plus"></i>&nbsp;Add to cart </button>
                  </div>
                </form>
              </div>
        </div>
      )
   
    }
   
  }
}

export default Addcart

